import { httpApi } from '../../_http';

/**
 * Property data required for product type determination.
 */
export interface ProductTypeProperty {
  propertyType?: string;
  propertyPurpose?: string;
}

/** Matches techlend-be BorrowerType for application-level classification */
export type ProductTypeBorrowerType = 'individual' | 'company' | 'company_trust' | 'individual_and_company_trust';

/** Matches techlend-be LoanPurpose values used by the single-security product matrix branch */
export type ProductTypeLoanPurpose = 'business_purpose' | 'complete_project_finance';

/**
 * Request payload for product type API.
 */
export interface ProductTypeRequest {
  incomingProperties?: ProductTypeProperty[];
  outgoingProperties: ProductTypeProperty[];
  supportingProperties?: ProductTypeProperty[];
  isPurchaseRetirementVillage?: boolean;
  borrowerType?: ProductTypeBorrowerType;
  loanPurpose?: ProductTypeLoanPurpose;
}

/**
 * Response from product type API.
 */
export interface ProductTypeResponse {
  loanType: 'commercial' | 'residential';
  pricingCategory: string;
  assessmentType: 'regulated' | 'unregulated';
}

/**
 * Determines the product type classification from property data.
 * Uses the backend product matrix logic to determine loan type, pricing category, and assessment type.
 */
export const getProductType = async (request: ProductTypeRequest): Promise<ProductTypeResponse> => {
  const { data } = await httpApi.post<ProductTypeResponse>('/public/product-type', request);
  return data;
};
